import { configureStore } from "@reduxjs/toolkit";
import CartReducer from "./CartSlicer"
import { CART_STORAGE_KEY } from "../utils/config"

export const store = configureStore({
    reducer:{
        cartslice:CartReducer,
    }
})

store.subscribe(()=>{
    try {
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(store.getState().cartslice));
    } catch (e) {
        // localStorage unavailable (e.g. private browsing quota) - skip persisting silently
    }
})